module.exports = __webpack_public_path__ + "img/evolve-info-icon.23e6c4c3.svg";